module.exports = __webpack_public_path__ + "img/table_no_result.afb1c19b.svg";